<template>
  <div class="part">
    <div class="con">
      <!--number-->
      <div class="number">04</div>
      <div class="head">
        <div class="title">小程序六大优势</div>
        <div class="mark">微信小程序不容错过，企业突围的有力武器！</div>
        <div class="spec">微信小程序无需安装触手可及，享有微信10亿月活用户，已开放50多个流量入口，深度连接用户、产品与服务，实现商家快速引流、客户轻松消费、互惠共赢创收。</div>
      </div>
      <!--list-->
      <ul class="list">
        <li class="item">
          <div class="front">
            <div class="icon icon1"></div>
            <div class="icon-text">小程序，大战略</div>
          </div>
          <div class="back back1">
            <div class="item-title">小程序，大战略</div>
            <div class="item-spec">小程序属于腾讯战略级项目，微信平台为小程序持续解放60余次新能力，迭代升级速度之快前所未有。</div>
          </div>
        </li>
        <!--02-->
        <li class="item">
          <div class="front">
            <div class="icon icon2"></div>
            <div class="icon-text">无需安装，触手可及</div>
          </div>
          <div class="back back2">
            <div class="item-title">无需安装，触手可及</div>
            <div class="item-spec">用户扫一扫或搜一下即可打开应用，不用担心是否安装太多应用的问题，应用将无处不在随处可用，也无需安装卸载，节省手机流量，释放手机内存。简化了用户使用步骤，提供了更轻松、更流畅的用户体验。</div>
          </div>
        </li>
        <!--03-->
        <li class="item">
          <div class="front">
            <div class="icon icon3"></div>
            <div class="icon-text">低门槛、低成本、高可用</div>
          </div>
          <div class="back back3">
            <div class="item-title">低门槛、低成本、高可用</div>
            <div class="item-spec">技术门槛低，开发周期短，无需适应多终端、多系统，大大节省时间、人力、金钱的成本；同时，可还原APP 80%以上的功能，操作更简单、使用更方便</div>
          </div>
        </li>
        <!--04-->
        <li class="item">
          <div class="front">
            <div class="icon icon4"></div>
            <div class="icon-text">推广更简单，营销更高效</div>
          </div>
          <div class="back back4">
            <div class="item-title">推广更简单，营销更高效</div>
            <div class="item-spec">小程序具备多种推广方式，可以绑定公众号，方便用户直接跳转使用；可以随手生成二维码、展示在朋友圈、印制在各种宣传资料……，帮助商家品牌全面曝光，促进用户快速裂变，从而带来更多的用户。</div>
          </div>
        </li>
        <!--05-->
        <li class="item">
          <div class="front">
            <div class="icon icon5"></div>
            <div class="icon-text">运营成本低、自带高流量</div>
          </div>
          <div class="back back5">
            <div class="item-title">运营成本低、自带高流量</div>
            <div class="item-spec">小程序运行于微信，直接享有10亿的月活用户，及万亿市场红利。小程序已开放的50多个流量入口，包括附近5公里可见，自动“吸睛”引流，为商家带来更多商机。</div>
          </div>
        </li>
        <!--06-->
        <li class="item">
          <div class="front">
            <div class="icon icon6"></div>
            <div class="icon-text">轻应用、大生态</div>
          </div>
          <div class="back back6">
            <div class="item-title">轻应用、大生态</div>
            <div class="item-spec">传统企业要想发展更多的优势，必须依据产品+线下+线上同时并行，完善网络系统，微信小程序可以很好的打通用户、内容资讯、商品服务之间的联系，直接在微生态体系内完成商业模式的闭环，实现用户与商品与服务的无缝链接，商家快速引流，客户轻松消费、互惠共赢创收。</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {

    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
.part{
  width: 100%;
  min-width: $min-width;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  margin-top: 170px;
  min-height: 100px;
  line-height: 1.0;
  .con{
    padding-top: 12px;
    .number{
      font-size: 180px;
      color:$theme-color;
      opacity: 0.1;
      position: absolute;
      top: 0;
      left: 230px;
      font-weight: bold;
    }
    .head{
      padding-left: 420px;
      .title{
        font-size: 48px;
        color:$theme-color;
        font-weight: bold;
        margin-bottom:32px;
      }
      .mark{
        font-size: 36px;
        color: #2cbb58;
        margin-bottom: 46px;
      }
      .spec{
        font-size: 16px;
        line-height: 1.6;
        margin-bottom: 100px;
        color:#666;
      }

    }

    .list{
      @include clearfix;
      .item{
        width: percent(400);
        height:260px;
        position: relative;
        box-sizing: border-box;
        cursor: pointer;
        float: left;
        margin-bottom: 10px;
        /*
        & + .item{
          margin-left: percent(30);
        }*/
        &:nth-of-type(4){
          margin-left: 0;
        }
        .front{
          position : absolute;
          width: 100%;
          @include both-center;
          .icon{
            width: 108px;
            height: 108px;
            margin: 0 auto 40px;
          }
          .icon-text{
            font-size: 18px;
            color:#666;
            text-align: center;
            font-weight: bold;
            word-break: keep-all;
          }
          .icon1{
            background-image: url("../../assets/images/04item1.png")
          }
          .icon2{
            background-image: url("../../assets/images/04item2.png")
          }
          .icon3{
            background-image: url("../../assets/images/04item3.png")
          }
          .icon4{
            background-image: url("../../assets/images/04item4.png")
          }
          .icon5{
            background-image: url("../../assets/images/04item5.png")
          }
          .icon6{
            background-image: url("../../assets/images/04item6.png")
          }
        }
        .back{
          opacity: 0;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          position: absolute;
          padding: 36px 120px 18px 24px;
          transform: translate(0, 60px);
          transition: transform 0.4s, opacity 0.4s;
          box-shadow: 0 0 10px rgba(0,0,0,.2);
          border-radius: 6px;
          background-position: right bottom;
          background-repeat: no-repeat;
          background-color:#fff;
          @media screen and (max-width:1200px){
            padding-right: 60px;
          }
          &.back1{
            background-image: url("../../assets/images/04itembg1.png");
          }
          &.back2{
            background-image: url("../../assets/images/04itembg2.png");
          }
          &.back3{
            background-image: url("../../assets/images/04itembg3.png");
          }
          &.back4{
            background-image: url("../../assets/images/04itembg4.png");
          }

          &.back5{
            background-image: url("../../assets/images/04itembg5.png");
          }
          &.back6{
            background-image: url("../../assets/images/04itembg6.png");
          }
          .item-title{
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 18px;
          }
          .item-spec{
            font-size: 14px;
            color: #999;
            line-height: 1.4;
          }

        }
        &:hover{
          .front{
            opacity: 0;
            transition: opacity 0.3s;
          }
          .back{
            opacity: 1.0;
            transform: translate(0,0);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/IndexPartFour.vue